// Lightweight service worker registration for PWA support.
// Only registers in production builds (CRA dev server interferes with SW caching).

export function registerServiceWorker() {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) return;
  // Skip in development — webpack-dev-server hot reload + SW caching = pain.
  if (process.env.NODE_ENV !== "production") return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((reg) => {
        // Listen for updates and notify if a new SW is waiting
        reg.addEventListener("updatefound", () => {
          const newWorker = reg.installing;
          if (!newWorker) return;
          newWorker.addEventListener("statechange", () => {
            if (newWorker.state === "installed" && navigator.serviceWorker.controller) {
              // A new version is available — could show a toast, but keep it silent for now.
              console.info("Purple INK: a new version is available. Reload to update.");
            }
          });
        });
      })
      .catch((err) => {
        console.warn("Service worker registration failed:", err);
      });
  });
}
